import SearchResultCard from './SearchResultCard.jsx'

export default function ResultsGrid({
    results,
    selectedId,
    onSelect,
    selectedDate,
    loading,
    error,
    isSaved,
    onToggleSave,
    plans,
    getItemPlans,
    onShowPlanPopup,
    cardVariant = 'default',
    hasMore = false,
    loadingMore = false,
    onLoadMore
}) {
    if (!loading && !error && results.length === 0) {
        return (
            <div className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm">
                No results found for this time window. Try adjusting your search.
            </div>
        )
    }

    if (loading) {
        return (
            <div className="rounded-xl border border-purple-200 bg-white p-4 text-sm text-slate-600 shadow-sm">
                Looking for events...
            </div>
        )
    }

    return (
        <>
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                {results.map(item => {
                    // Randomly assign variant based on item ID (deterministic per item)
                    const useHoverVariant = cardVariant === 'default'
                        ? parseInt(item.id.slice(-8), 36) % 2 === 0
                        : cardVariant === 'hover'

                    // Get the colors of plans this item is in
                    const itemPlanIds = getItemPlans?.(item.id, selectedDate) || []
                    const itemPlanColors = itemPlanIds
                        .map(planId => plans?.find(p => p.id === planId)?.color)
                        .filter(Boolean)

                    return (
                        <SearchResultCard
                            key={item.id}
                            item={item}
                            isSelected={selectedId === item.id}
                            onSelect={onSelect}
                            selectedDate={selectedDate}
                            isSaved={isSaved?.(item.id)}
                            onToggleSave={onToggleSave}
                            itemPlanColors={itemPlanColors}
                            onShowPlanPopup={onShowPlanPopup}
                            variant={useHoverVariant ? 'hover' : 'default'}
                        />
                    )
                })}
            </div>

            {/* Show More button */}
            {hasMore && !loading && (
                <div className="flex justify-center pt-4">
                    <button
                        onClick={onLoadMore}
                        disabled={loadingMore}
                        className="rounded-lg bg-purple-600 px-6 py-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        {loadingMore ? 'Loading more...' : 'Show More'}
                    </button>
                </div>
            )}
        </>
    )
}
